module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "academy-course-item",
    on: {
      "click": _vm.itemClicked
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.coverPic + '@140h_230w_2e_90Q'
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "title": _vm.item.title
    }
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('h5', {
    attrs: {
      "title": _vm.item.subTitle
    }
  }, [_vm._v(_vm._s(_vm.item.subTitle))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc47541","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/Announcement.vue
// module id = 784
// module chunks = 0